package features.members.ui.modals

import kotlinx.browser.document
import kotlinx.html.*
import kotlinx.html.dom.append
import kotlinx.html.js.onClickFunction
import org.w3c.dom.HTMLElement
import shared.ui.ModalManager
import features.members.handlers.exportMembers
import features.members.handlers.testDummyExport

object ImportExportModal {
    fun render(root: HTMLElement) {
        root.append {
            div(classes = "modal-content fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-dark-800 border border-dark-700 rounded-2xl p-6 w-full max-w-2xl z-[101] hidden shadow-2xl scale-95 opacity-0 transition-all duration-300") {
                id = "import-export-modal"
                
                // Header
                div(classes = "flex justify-between items-center mb-6") {
                    h2(classes = "text-2xl font-bold") { +"Import/Export Members" }
                    button(classes = "text-slate-400 hover:text-white text-2xl") {
                        onClickFunction = { ModalManager.close() }
                        +"×"
                    }
                }
                
                // Import Section
                div(classes = "mb-8") {
                    h3(classes = "text-lg font-bold mb-4 flex items-center gap-2") {
                        span { +"📥" }
                        +"Import Members"
                    }
                    p(classes = "text-sm text-slate-400 mb-4") {
                        +"Upload a file to import members to your team"
                    }
                    
                    div(classes = "grid grid-cols-3 gap-3") {
                        // CSV Import
                        button(classes = "bg-dark-700 hover:bg-dark-600 border border-dark-600 rounded-xl p-4 transition text-center") {
                            onClickFunction = {
                                val input = document.createElement("input") as org.w3c.dom.HTMLInputElement
                                input.type = "file"
                                input.accept = ".csv"
                                input.onchange = {
                                    js("handleFileImport")(input, "csv")
                                    null
                                }
                                input.click()
                            }
                            div(classes = "text-3xl mb-2") { +"📄" }
                            div(classes = "font-bold text-white") { +"CSV" }
                            div(classes = "text-xs text-slate-400 mt-1") { +"Comma-separated" }
                        }
                        
                        // Excel Import
                        button(classes = "bg-dark-700 hover:bg-dark-600 border border-dark-600 rounded-xl p-4 transition text-center") {
                            onClickFunction = {
                                val input = document.createElement("input") as org.w3c.dom.HTMLInputElement
                                input.type = "file"
                                input.accept = ".xlsx,.xls"
                                input.onchange = {
                                    js("handleFileImport")(input, "excel")
                                    null
                                }
                                input.click()
                            }
                            div(classes = "text-3xl mb-2") { +"📊" }
                            div(classes = "font-bold text-white") { +"Excel" }
                            div(classes = "text-xs text-slate-400 mt-1") { +"XLSX/XLS format" }
                        }
                        
                        // Template Download
                        button(classes = "bg-brand-cyan/20 hover:bg-brand-cyan/30 border border-brand-cyan/30 rounded-xl p-4 transition text-center") {
                            onClickFunction = { js("downloadCSVTemplate")() }
                            div(classes = "text-3xl mb-2") { +"📋" }
                            div(classes = "font-bold text-brand-cyan") { +"Template" }
                            div(classes = "text-xs text-slate-400 mt-1") { +"Download sample" }
                        }
                    }
                }
                
                // Divider
                div(classes = "border-t border-dark-700 my-6")
                
                // Export Section
                div {
                    h3(classes = "text-lg font-bold mb-4 flex items-center gap-2") {
                        span { +"📤" }
                        +"Export Members"
                    }
                    p(classes = "text-sm text-slate-400 mb-4") {
                        +"Download your team members list in various formats"
                    }
                    
                    div(classes = "grid grid-cols-3 gap-3") {
                        // CSV Export
                        button(classes = "bg-dark-700 hover:bg-dark-600 border border-dark-600 rounded-xl p-4 transition text-center") {
                            onClickFunction = { exportMembers("csv") }
                            div(classes = "text-3xl mb-2") { +"📄" }
                            div(classes = "font-bold text-white") { +"CSV" }
                            div(classes = "text-xs text-slate-400 mt-1") { +"For spreadsheets" }
                        }
                        
                        // Excel Export
                        button(classes = "bg-dark-700 hover:bg-dark-600 border border-dark-600 rounded-xl p-4 transition text-center") {
                            onClickFunction = { exportMembers("excel") }
                            div(classes = "text-3xl mb-2") { +"📊" }
                            div(classes = "font-bold text-white") { +"Excel" }
                            div(classes = "text-xs text-slate-400 mt-1") { +"XLSX format" }
                        }
                        
                        // Test Dummy Layout (Dev Only)
                        button(classes = "bg-amber-500/10 hover:bg-amber-500/20 border border-amber-500/30 rounded-xl p-4 transition text-center") {
                            onClickFunction = { testDummyExport() }
                            div(classes = "text-3xl mb-2") { +"🧪" }
                            div(classes = "font-bold text-amber-500") { +"Test Layout" }
                            div(classes = "text-xs text-slate-400 mt-1") { +"Dummy Data 100%" }
                        }
                    }
                }
                
                // Footer
                div(classes = "flex justify-end gap-3 mt-6 pt-6 border-t border-dark-700") {
                    button(classes = "px-6 py-2 rounded-lg bg-dark-700 hover:bg-dark-600 text-white transition") {
                        onClickFunction = { ModalManager.close() }
                        +"Close"
                    }
                }
            }
        }
    }
}
